module.exports = __webpack_public_path__ + "static/img/sharetips.c604f83.1770200680838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sharetips.png
// module id = kg+M
// module chunks = 69